import {
  RequirementVersionScope,
  RequirementVersionTransitionStrategy
} from "@wingspanhq/payments/dist/interfaces";

export const getTransitionCurrentValue = (
  scope: RequirementVersionScope,
  transitionMethod: RequirementVersionTransitionStrategy
): { primary: string; secondary?: string; disabled?: boolean } => {
  if (scope === RequirementVersionScope.NewOnly) {
    return { disabled: true, primary: "—" };
  }

  if (scope === RequirementVersionScope.All) {
    return transitionMethod === RequirementVersionTransitionStrategy.Renewal
      ? {
          disabled: true,
          primary: "—",
          secondary: "Complete requirements valid until expiration"
        }
      : {
          disabled: true,
          primary: "—",
          secondary: "None (all transitioning to new)"
        };
  }

  return transitionMethod === RequirementVersionTransitionStrategy.Renewal
    ? {
        disabled: true,
        primary: "—",
        secondary: "Complete requirements remain valid"
      }
    : {
        disabled: true,
        primary: "—",
        secondary: "Incomplete reset immediately"
      };
};

export const getTransitionNewValue = (
  scope: RequirementVersionScope,
  transitionMethod: RequirementVersionTransitionStrategy,
  renewalDeadlineDays: number
): { primary: string; secondary?: string } => {
  if (scope === RequirementVersionScope.NewOnly) {
    return { primary: "New assignments only" };
  }

  return transitionMethod === RequirementVersionTransitionStrategy.Renewal
    ? {
        primary: `Effective: ${renewalDeadlineDays}-day deadline`,
        secondary:
          scope === RequirementVersionScope.All
            ? "Complete by effective date"
            : "Incomplete until satisfied"
      }
    : {
        primary: "Effective: immediately",
        secondary: "Incomplete immediately until satisfied"
      };
};
